import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  matchPath,
} from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./components/Login";
import Register from "./components/Register";
import ResetPassword from "./components/ResetPassword";
import ChangePassword from "./components/ChangePassword";
import DashboardSites from "./components/DashboardSites";
import DashboardFootprint from "./components/DashboardFootprint";
import PrivateRoute from "./components/PrivateRoute";
import Video from "./components/Video";
import RedirectManager from "./components/RedirectManager";
import Form from "./components/Onboarding/Form";
import Account from "./components/Settings/Account";
import Notification from "./components/Settings/Notification";
import Sidebar from "./components/Settings/Sidebar";
import Setting from "./components/Settings/Setting";
import FailToast from "./components/Toast/FailToast";
// import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout/Layout";
import Guide1 from "./components/Guide/Guide1";
import FootprintHomePage from "./pages/FootprintHomePage";
import FootprintInfoPage from "./pages/FootprintInfoPage";
import { pathToRegexp } from "path-to-regexp";
import FootprintStatusListPage from "./pages/FootprintStatusListPage";
import Footprint_Info_List from "./components/Footprint/Footprint_Info_list";
import Footprint_Status_List from "./components/Footprint/Footprint_Status_List";
import Footprint_All_List from "./components/Footprint/Footprint_All_List";
import Popup_End_Card from "./components/Card/Popup_End_Card";
import SuccessFootprint from "./components/SuccessFootprint";
import Footprint_Guide from "./components/Guide/Footprint_Guide";
import Footprint_Landing_Card from "./components/Card/Footprint_Landing_Card";
import FailedVideo from "./components/FailedVideo";
import Setting_Guide from "./components/Guide/Setting_Guide";
import { Navigate } from "react-router-dom";
import Footprint_Save from "./components/Footprint/Footprint_Save";
import Footprint_Schedule from "./components/Footprint/Footprint_Schedule";
import { VideoLogs } from "./components/VideoLogs";
import VideoDesign from "./components/VideoDesign";
import TagManager from "react-gtm-module";
import ExtensionCard from "./components/Card/ExtensionCard";
import AddWebsitePage from "./pages/AddWebsitePage";
import ResetExpireLink from "./pages/ResetExpireLink";
import TestLandingPage from "./pages/TestLandingPage";
import Auth from "./components/Images/Auth";
import SettingLayout from "./components/Layout/SettingLayout";
import TestDetailsPage from "./pages/TestDetailsPage";
import Test_Schedule from "./components/Footprint/Test_Schedule";
import Integration from "./components/Settings/Integration";
import Whitelisting from "./components/Settings/Whitelisting";
import Organisation from "./components/Settings/Organisation";
import Urls from "./components/Settings/Urls";
import TestInfoPage from "./pages/TestInfoPage";
import DashboardPage from "./pages/DashboardPage";
import ShareTestRun from "./pages/ShareTestRun";
import { WebSocketContext } from "./websocket";
import Final from "./Final";
import Reports from "./pages/Reports";
import GoRedirect from "./components/Share Test/GoRedirect";
import Home from "./components/Onboarding/Home";
import Website from "./components/Onboarding/Website";
import ClickStepTutorial from "./components/Tutorial/ClickStepTutorial";
import EmailVerification from "./pages/EmailVerification";
import axios from 'axios';
import { baseUrl } from './config';
import { useDispatch } from "react-redux";
import { getUserDetails } from "./features/user/userSlice";
import { useSelector } from 'react-redux';

const LayoutRoutes = () => (
  <Routes>
    {/* Default Layout */}
    <Route element={<Layout />}>
      <Route
        path="/:websiteId/dashboard"
        element={
          <PrivateRoute>
            {/* <Dashboard /> */}
            <DashboardPage />
          </PrivateRoute>
        }
      />s

      <Route
        path="/footprint"
        element={
          <PrivateRoute>
            <FootprintHomePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/guide"
        element={
          <PrivateRoute>
            <Guide1 />
          </PrivateRoute>
        }
      />
      <Route
        path="footprint-list"                // why ??? / is missing
        element={
          <PrivateRoute>
            <FootprintStatusListPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/footprint-info"
        element={
          <PrivateRoute>
            <FootprintInfoPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/:websiteId/test-list"
        element={
          <PrivateRoute>
            <TestLandingPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/:websiteId/:footprintId/test-info"
        element={
          <PrivateRoute>
            <TestInfoPage />
          </PrivateRoute>
        } 
      />

      <Route
        path="/:websiteId/test"
        element={
          <PrivateRoute>
            <TestDetailsPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/footprint-info-list"
        element={
          <PrivateRoute>
            <Footprint_Info_List />
          </PrivateRoute>
        }
      />

      <Route
        path="/footprint-status-list"
        element={
          <PrivateRoute>
            <Footprint_Status_List />
          </PrivateRoute>
        }
      />

      <Route
        path="/:websiteId/footprint-all-list"
        element={
          <PrivateRoute>
            <Footprint_All_List />
          </PrivateRoute>
        }
      />
      <Route
        path="/website/:websiteId/footprint/:footprintId/video/:videoId"
        element={
          <PrivateRoute>
            {/* <Video /> */}
            <FailedVideo />
          </PrivateRoute>
        }
      />

      <Route
        path="/footprint/:footprintId/website/:websiteId"
        element={
          <PrivateRoute>
            <Footprint_Schedule />
          </PrivateRoute>
        }
      />
      <Route
        path="/footprint/:id/:websiteName"
        element={
          <PrivateRoute>
            <Video />
          </PrivateRoute>
        }
      />


      <Route
        path="/footprint/demo"
        element={
          <PrivateRoute>
            <Final />
          </PrivateRoute>
        }
      />

      <Route
        path="/successFootprintPopup"
        element={
          <PrivateRoute>
            <SuccessFootprint />
          </PrivateRoute>
        }
      />

      <Route
        path="/onboardSchedule"
        element={
          <PrivateRoute>
            <Footprint_Guide />
          </PrivateRoute>
        }
      />

      <Route
        path="/footprintLanding"
        element={
          <PrivateRoute>
            <Footprint_Landing_Card />
          </PrivateRoute>
        }
      />

      <Route
        path="/Savefootprint/:footprintId/website/:websiteId"
        element={
          <PrivateRoute>
            {/* <Footprint_Save /> */}
            <Test_Schedule />
          </PrivateRoute>
        }
      />

      {/* <Route
        path="/logs"
        element={
          <PrivateRoute>
            <VideoLogs />
          </PrivateRoute>
        }
      /> */}

      <Route
        path="/logs"
        element={
          <PrivateRoute>
            <VideoDesign />
          </PrivateRoute>
        }
      />
      <Route
        path="/card"
        element={
          <ExtensionCard />
        }
      />

      <Route
        path="/website/:websiteId/footprint/:footprintId/video/:videoId"
        element={
          <PrivateRoute>
            {/* <Video /> */}
            <FailedVideo />
          </PrivateRoute>
        }
      />
      {/* <Route path="/onboarding"
        element={
          <PrivateRoute>
            <Form />
          </PrivateRoute>} /> */}
      <Route
        path="/addWebsite"
        element={
          <PrivateRoute>
            <AddWebsitePage />
          </PrivateRoute>
        }
      />



      {/* <Route
        path="/share-test/website/:websiteId/footprint/:footprintId/video/:videoId/user/userId"
      
        element={
            <ShareTestRun />
        }
      /> */}

      <Route
        path="/share-test/website/:websiteId/footprint/:footprintId/video/:videoId"
        element={<ShareTestRun />}
      />






      {/* Add other default layout routes here */}
    </Route>


    {/* Setting Layout */}
    <Route element={<SettingLayout />}>

      <Route
        path="/setting/account"
        element={
          <PrivateRoute>
            <Account />
          </PrivateRoute>
        }
      />
      <Route
        path="/setting/notifications"
        element={
          <PrivateRoute>
            <Notification />
          </PrivateRoute>
        }
      />
      <Route
        path="/setting/organisation"
        element={
          <PrivateRoute>
            <Organisation />
          </PrivateRoute>
        }
      />
      <Route
        path="/setting/Integration"
        element={
          <PrivateRoute>
            <Integration />
          </PrivateRoute>
        }
      />
      <Route
        path="/setting/url"
        element={
          <PrivateRoute>
            {/* <Notification /> */}
            <Urls />

          </PrivateRoute>
        }
      />
      <Route
        path="/setting/whitelisting"
        element={
          <PrivateRoute>
            <Whitelisting />

          </PrivateRoute>
        }
      />


      <Route
        path="/reports"
        element={
          <PrivateRoute>
            <Reports />

          </PrivateRoute>
        }
      />







    </Route>
  </Routes>
);




const NoLayoutRoutes = ({ websiteId, isAuth }) => (
  <Routes>
    <Route path="/signUp" element={<Register />} />
    <Route path="/signIn" element={<Login />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/onboarding"
      element={
        <PrivateRoute>
          <Form />
        </PrivateRoute>} />
    {/* <Route path="/onboarding"
      element={
        <Form />

      } /> */}
    <Route path="/verify-email"
      element={
        <PrivateRoute>
          <EmailVerification />
        </PrivateRoute>} />
    {/* <Route path="/verify-email"
      element={
        <EmailVerification />
      } /> */}
    <Route path="/user/reset/password/:token" element={<ChangePassword />} />
    <Route path="/reset-expire-link" element={<ResetExpireLink />} />
    <Route path="/" element={websiteId ? <Navigate to={`/${websiteId}/dashboard`} /> : <Navigate to="/signIn" />} />
    <Route path="/go/:code" element={<GoRedirect />} />

    <Route
      path="/on"
      element={
        <ClickStepTutorial />
      }
    />

  </Routes>
);



const AppRoutes = () => {
  const location = useLocation();

  //Socket Implementation.
  const socket = useContext(WebSocketContext);
  const isAuth = localStorage.getItem("isAuth");
  const websiteId = localStorage.getItem('selectedWebsiteId')
  // const userId = localStorage.getItem("userId")

   const dispatch = useDispatch();


  // const token = localStorage.getItem("Token");
    //  const decoded = jwtDecode(token);
    //   const { username, userId } = decoded;
  const userData = useSelector((state) => state.auth.user) || {};
    console.log("login data in app.js:", userData);
    const userId = userData?.userId || localStorage.getItem("userId");
  useEffect(() => {
    if (token) {
      dispatch(getUserDetails({ userId }));


    }
  }, []);
    const token = localStorage.getItem("Token");
   
  


  useEffect(() => {

    const sendOnline = () => {
      socket.emit("online", userId);
    };

    const sendOffline = () => {
      socket.emit("offline", userId);
    };

    const handleConnect = () => {
      console.log("mai join room hu")
      socket.emit("join room", userId);
    };

    const handleDisconnect = () => {
      socket.emit("leave room", userId);
    };


    if (userId) {
      socket.emit("setup", userId);

      window.addEventListener("load", sendOnline);
      window.addEventListener("beforeunload", sendOffline);

      socket.on("connect", handleConnect);
      socket.on("disconnect", handleDisconnect);
    }

    return () => {
      window.removeEventListener("load", sendOnline);
      window.removeEventListener("beforeunload", sendOffline);
      socket.off("connect", handleConnect);
      socket.off("disconnect", handleDisconnect);
    };
  }, [socket, userId]);

  useEffect(() => {
    if (userId) {
      socket.emit("join room", userId);
    }
  }, [userId]);

  const noLayoutRoutes = [
    "/",
    "/signUp",
    "/signIn",
    "/onboarding",
    "/reset-password",
    // "/addWebsite",
    "/reset-expire-link",
    "/verify-email",
    "/user/reset/password/:token",

  ];



  const isNoLayoutRoute = noLayoutRoutes.some((route) => {
    const regexp = pathToRegexp(route);
    return regexp.test(location.pathname);
  });





  return isNoLayoutRoute ? <NoLayoutRoutes websiteId={websiteId} isAuth={isAuth} /> : <LayoutRoutes />;
};






const App = () => {



  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "GTM-MGMH4WN8",
    };
    TagManager.initialize(tagManagerArgs);
  }, []);

  useEffect(() => {
    const link = document.querySelector("link[rel='icon']");
    if (link) {
      link.href = "/Testtube logo.png"; // Ensure this path is correct
    } else {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = "/Testtube logo.png";
      document.head.appendChild(newLink);
    }
  }, []);







  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;
